import { Dialog } from '@kdocs/kdesign-vue'
import defaultFooter from './Footer.vue'
import './index.scss'

function isFunction(fn) {
  return Object.prototype.toString.call(fn)=== '[object Function]'
}

export default function(options) {
  const { Vue, store, initFooter, i18n, ElDialog } = options
  const DialogMap = new Map()
  let i = 0
 
  function DialogFactory (props) {
    const {
      title,
      content,
      footer,
      showFooter,
      confirmText,
      cancelText,
      showCancelButton,
      width = '450px',
      closeOnClickModal = false,
      showConfirmButton,
      onClose,
      onConfirm = function() {},
      customClass,
      contentProps = {},
      destroyOnClose = true,
      afterClose,
      disableCloseAnimation,
      footerCenter,
      id,
      duration,
      confirmButtonType,
      ...otherPorps
    } = props
    if (id && DialogMap.get(id)) {
      console.error('dialog id 已存在，推荐使用Symbol类型或者唯一标识作为dialog id的值')
      return DialogMap.get(id)
    }
    let instance
    const dom = document.createElement('div')
    document.body.appendChild(dom)
    const isSlotTitle = typeof title !== 'string'
    const isSlotContent = typeof content !== 'string'
    const DialogComp = ElDialog || Dialog
    instance = new Vue({
      el: dom,
      store,
      ...(i18n ? { i18n } : {}),
      components: {
        Dialog: DialogComp,
        ...( isSlotContent ?  { Content: content } : {}),
        ...( isSlotTitle ?  { Title: title } : {}),
        Footer: footer || initFooter || defaultFooter
      },
      data() {
        return {
          visible: true,
          confirmLoading: false,
          contentProps: { ...contentProps }, // TODO 考虑深拷贝
          ...( isSlotTitle ? { } : { title })
        }
      },
      computed: {
        titleRef() {
          return this.$refs.title
        },
        contentRef() {
          return this.$refs.content
        },
        footerRef() {
          return this.$refs.footer
        },
      },
      methods: {
        close() {
          this.visible = false
        },
        show() {
          this.visible = true
        },
        // 如果实例销毁，就不能再使用show方法了。
        destroy() {
          DialogMap.delete(instance.id)
          document.body.removeChild(this.$el)
          this.$destroy()
        }
      },
      render(h) {
        const that = this
        const closeFunc = isFunction(onClose) ? onClose.bind(that) : that.close.bind(that)
        const confirmFunc = onConfirm.bind(that)
        const vnodeConstructor = h('div').constructor
        return h('Dialog', {
          props: {
            visible: this.visible,
            width,
            closeOnClickModal,
            customClass: `mt-dialog ${customClass || ''} ${title ? '' : 'mt-dialog--hidden-title'}`,
            ...( isSlotTitle ? { } : { title: this.title }),
            ...otherPorps
          },
          class: {
            'disable-close-animation': disableCloseAnimation,
            'mt-dialog__wrapper': true,
          },
          scopedSlots: {
            default: () => {
              if(typeof content === 'string') {
                return h('div', {}, content)
              } else if (content instanceof vnodeConstructor) {
                return content
              } 
              return (
                h('Content', {
                  props: {
                    instance: that,
                    onConfirm: confirmFunc,
                    onClose: closeFunc,
                    ...contentProps
                  },
                  ref: 'content'
                })
              )
            },
            ...( isSlotTitle ? {
              title: () => {
                return title instanceof vnodeConstructor ? title : (
                  h('Title', {
                    props: {
                      instance: that,
                      onClose: closeFunc,
                    },
                    ref: 'title'
                  })
                )
              }
            } : {}),
          },
          on: {
            'update:visible'(visible) {
              if(!visible && isFunction(onClose)) {
                onClose.call(that, 'close')
              } else {
                that.visible = visible
              }
            },
            close() {
              if(isFunction(afterClose)) {
                afterClose()
              }
            },
            // Dialog 关闭动画结束时的回调
            closed() {
              if(destroyOnClose) {
                that.destroy()
              }
            }
          }
        }, [
          ...(showFooter || footer ? [
            h('Footer', {
              props: {
                instance: that,
                confirmText: confirmText || (i18n ? i18n.t('general_confirm') : undefined), 
                cancelText: cancelText || (i18n ? i18n.t('cancel') : undefined), 
                confirmLoading: that.confirmLoading,
                onConfirm: confirmFunc,
                onClose: closeFunc,
                showCancelButton,
                showConfirmButton,
                center: footerCenter,
                confirmButtonType
              },
              slot: 'footer',
              ref: 'footer'
            })
          ] : [])
        ])
      }
    })
    if (id) {
      instance.id = id 
    } else {
      instance.id = ++i
    }
    DialogMap.set(instance.id, instance)
    if (duration) {
      setTimeout(() => {
        DialogFactory.close(instance.id)
      }, duration)
    }
    return instance
  }

  DialogFactory.close = function(instanceId) {
    if (instanceId) {
      const instance = DialogMap.get(instanceId)
      typeof instance?.close === 'function' && instance.close()
    } else {
      new Map(DialogMap).forEach(instance => {
        typeof instance?.close === 'function' && instance.close()
      })
      DialogMap.clear()
    }
  }
  return DialogFactory
}
